The end date of the posting.

Scheme requirements:

- For the `seekAnz` scheme this must be no more than 30 days in the future.

  If an end date is omitted, the job ad will default to the maximum period of 30 calendar days.
  The precise end date can be queried from the `PostingInstruction.end` field once the job ad goes live.
